$(document).ready(function(){

 // sessionStorage.setItem("logindfsafSAFASFData","fsdfdf");
//   setTimeout(function() {
// jQuery(".cstm_collection_partfinder_section").prependTo('.usf-facets__body .usf-facet:nth-child(4)');
//                     }, 6000);

   setTimeout(function() {
jQuery(".cstm_collection_partfinder_section").prependTo('.cstm_category_filter_partfinder');
                    }, 6000);

  //move geolocation from footer to header
setTimeout(function() {
jQuery(".locale-selectors__container").appendTo('.cstm_geolocation_footer');
                    }, 4000);
  setTimeout(function() {
jQuery(".locale-selectors__container").appendTo('.cstm_geolocation_footer');
                    }, 6000);
  
     // INJECTOR CALCULATOR JS

 function calc_inj(){
  
    var  target_crank = $("#target_crank").val();
    // var  power_unit = $("#powet_unit").val();
   var  power_unit = $("#powet_unit option:selected").attr("data-power_unit");
   var  power_wheel_type = $("#powet_unit option:selected").attr("data-power_wheel_type");
    var  no_of_inject = $("#no_of_inject").val();
    var  type_ind = $("#type_ind").val();
    var  fuel_type = $("#fuel_type").val();
    var  ethanol_type = $("#ethanol_type").val();
    var  opt_bsfc = $("#opt_bsfc").val();
    // var  max_duty_cycle = parseInt($("#max_duty_cycle").val()) / parseInt(100);
     var  max_duty_cycle = 0.80;
    // var  inj_flow = $("#inj_flow").val();
    var  flowv1 = $("#Flowv1").val();
    var power_multiplyer = 1;


   var ind_typp = jQuery(".induc_type").val()
   var fuel_typp = jQuery('select[name="fuel_type"]').val();
   var bsfc = 0;
// if(power_unit == 'KW')
// {
//   target_crank = 0.7457 * target_crank ;
// }
// else if (power_unit == 'PS') {
//      target_crank = 0.986 * target_crank ;
// }
   // if(power_wheel_type == 'HPRW' || power_wheel_type == 'KWRW' )
   // {
   //   target_crank = 0.75 * target_crank ;
   // }

   if(power_wheel_type == 'HPRW')
   {
     target_crank = target_crank/ 0.75;
   }
   else if(power_wheel_type == 'KWE')
   {
   target_crank = target_crank * 1.34102;
     
   }
   else if(power_wheel_type == 'KWRW')
   {
   target_crank = target_crank / (0.7457 * 0.75 );
     
   }

      if(ind_typp == 'Turbo/Supercharged' && fuel_typp == 'Pump Fuel'){
      bsfc = 0.6;
      }
      else if(ind_typp == 'Naturally Aspirated' && fuel_typp == 'Pump Fuel'){
      bsfc = 0.48;
      }
      else if(ind_typp == 'Turbo/Supercharged' && fuel_typp == 'E85'){
      bsfc = 0.82;
      }
      else if(ind_typp == 'Naturally Aspirated' && fuel_typp == 'E85'){
      bsfc = 0.68;
      } 
      
      // if(fuel_typp == 'Ethanol')
      // {
      // if(ethanol_type == 'E30' && ind_typp == 'Turbocharged')
      // {
      //     bsfc = 0.57;
      // }
      // else if(ethanol_type == 'E30' && ind_typp == 'Supercharged'){
      // bsfc = 0.62;
      // }
      // else if(ethanol_type == 'E30' && ind_typp == 'Naturally Aspirated'){
      // bsfc = 0.5;
      // }
      // else if(ethanol_type == 'E85' && ind_typp == 'Turbocharged')
      // {
      //     bsfc = 0.64;
      // }
      // else if(ethanol_type == 'E85' && ind_typp == 'Supercharged'){
      // bsfc = 0.7;
      // }
      // else if(ethanol_type == 'E85' && ind_typp == 'Naturally Aspirated'){
      // bsfc = 0.57;
      // }
      // else if(ethanol_type == 'E98' && ind_typp == 'Turbocharged')
      // {
      //     bsfc = 0.73;
      // }
      // else if(ethanol_type == 'E98' && ind_typp == 'Supercharged'){
      // bsfc = 0.8;
      // }
      // else if(ethanol_type == 'E98' && ind_typp == 'Naturally Aspirated'){
      // bsfc = 0.66;
      // }
      
      // }

    // console.log(bsfc);
    if(power_unit == 'KW')
    {
    power_multiplyer = 1.341 ;
    }
    else if(power_unit == 'PS')
    {
     power_multiplyer = 0.986 ;
    }
    // console.log(power_multiplyer);
    
    var inj_flow = (target_crank * bsfc  )/ (no_of_inject * max_duty_cycle );
   
if(flowv1 == 'cc/min')
{
  inj_flow = inj_flow * 10.5;
}
else if(flowv1 == 'g/min')
   {
     inj_flow = inj_flow/0.132277 ;
   }

    // var res_finn = parseFloat(inj_flow.toPrecision(2));
    var res_finn = inj_flow.toFixed(0);
   if(isNaN(res_finn) || res_finn == 'Infinity') {
var res_finn = 0;
}
    $("#inj_flow").val(res_finn);
   $("#rated_flow_qty").val(res_finn);
     
}
    $('#fuel_type').on("change",function() {
    if($(this).val() == 'Ethanol')
    {
    $("#ethanol_type").show();
    }
    else
    {
    $("#ethanol_type").hide();
    }
    });
    $('.injector_table select').on("change",function() {
    calc_inj();
      var  flowv1 = $("#Flowv1").val();
      $("#rated_flow_unit").val(flowv1).trigger("change");
      $("#actual_flow_rate_unit").val(flowv1);
    });
    calc_inj();
    $ (".injector_table :input").on("keyup change", function(e) {
    calc_inj();
    })

 // underroot of(Actual Fuel Pressure/ Rated Fuel Pressure ) multiply by Rated Flow 

    $ (".flow_table :input").on("keyup change", function(e) {
     calc_flow_rate();
    });

  $('.flow_table select').on("change",function() {
calc_flow_rate();
  });
    $("#projectKey").change(function() {
    // calc_flow_rate();
    });

  function calc_flow_rate(){
    var  rated_flow_qty = $("#rated_flow_qty").val();
    var  rated_fuel_pressure = $("#rated_fuel_pressure").val();
    // var  actual_fuel_pressure = $("#actual_fuel_pressure").val();
     var  actual_fuel_pressure = 43.5;
    var rated_flow_unit = $("#rated_flow_unit").val();
    var res = 0;
    
    var  rated_fuel_pressure = rated_fuel_pressure * 14.5038;
    
    if(actual_fuel_pressure != '' && rated_fuel_pressure != '' && rated_flow_qty != '') 
    {
    var res = Math.sqrt(rated_fuel_pressure/actual_fuel_pressure) * rated_flow_qty ; 
     // var res_fix = parseFloat(res.toFixed(2));
      var res_fix = Math.round(res);
    
    $("#actual_flow_rate").val(res_fix);
    }
    $("#actual_flow_rate").val(res_fix);
    $("#actual_flow_rate_unit").val(rated_flow_unit).trigger("change");

}
  $("#calclate_actual_flow").click(function() {
    calc_flow_rate();
  });
   calc_flow_rate();
  

$('.thumbnail-list.list-unstyled').slick({
  dots: false,
  infinite: false,
vertical: true,
  speed: 300,
   prevArrow:'<span class="pre_btn"><img src="https://cdn.shopify.com/s/files/1/0731/5904/9498/files/left_large_003742c8-b6f0-450d-bc9c-c909c0a9cd16.png?v=1679303535" ></span>',
     nextArrow:'<span class="next_btn"><img src="https://cdn.shopify.com/s/files/1/0731/5904/9498/files/right_large_272fc568-267e-4507-bc13-af5d8bbd5300.png?v=1679303535"></span> ',
  slidesToShow: 4,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }

  ]
});


  
$('.top_bann_slid').slick({
  dots: false,
  infinite: false,
  speed: 300,
   prevArrow:'<span class="pre_btn"><img src="https://cdn.shopify.com/s/files/1/0731/5904/9498/files/left_large_003742c8-b6f0-450d-bc9c-c909c0a9cd16.png?v=1679303535" ></span>',
     nextArrow:'<span class="next_btn"><img src="https://cdn.shopify.com/s/files/1/0731/5904/9498/files/right_large_272fc568-267e-4507-bc13-af5d8bbd5300.png?v=1679303535"></span> ',
  slidesToShow: 1,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }

  ]
});
	

    
  $('.cstm_testi_content_slid').slick({
  dots: false,
  infinite: false,
  speed: 300,
   prevArrow:'<span class="pre_btn"><img src="https://cdn.shopify.com/s/files/1/0731/5904/9498/files/left_large_003742c8-b6f0-450d-bc9c-c909c0a9cd16.png?v=1679303535" ></span>',
     nextArrow:'<span class="next_btn"><img src="https://cdn.shopify.com/s/files/1/0731/5904/9498/files/right_large_272fc568-267e-4507-bc13-af5d8bbd5300.png?v=1679303535"></span> ',
  slidesToShow: 1,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }

  ]
});

   $('.home_prod_slider').slick({
  dots: false,
  infinite: true,
  speed: 300,
   prevArrow:'<span class="pre_btn"><img src="https://cdn.shopify.com/s/files/1/0731/5904/9498/files/left_large_003742c8-b6f0-450d-bc9c-c909c0a9cd16.png?v=1679303535" ></span>',
     nextArrow:'<span class="next_btn"><img src="https://cdn.shopify.com/s/files/1/0731/5904/9498/files/right_large_272fc568-267e-4507-bc13-af5d8bbd5300.png?v=1679303535"></span>',
  slidesToShow: 4,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }

  ]
});

$(".tab_head_num a").each(function(){
$(this).click(function(){
$('.prod_slid')[0].slick.refresh();
});
});

$(".tab_head_num a").each(function(){
$(this).click(function(){
$('.prod_slid')[2].slick.refresh();
});
});

  $("video").click(function() {
    var video = $("#testimonial_video").get(0);

    if ( video.paused ) {
        video.play();
        $(".play_icon").hide();
        $(".pause").show();
    } else {
        video.pause();
        $(".play_icon").show();
        $(".pause").hide();
    }

    return false;
});
$(".play_icon").click(function(){
var video = $("#testimonial_video").get(0);
 if ( video.paused ) {
        video.play();
        $(".play_icon").hide();
        $(".pause").show();
    } else {
        video.pause();
        $(".play_icon").show();
        $(".pause").hide();
    }
});
  
$(window).scroll(function() {
   var top_of_element = ($("#testimonial_video").offset() || { "top": NaN }).top;
    var bottom_of_element = ($("#testimonial_video").offset() || { "top": NaN }).top + $("#testimonial_video").outerHeight();
    var bottom_of_screen = $(window).scrollTop() + $(window).innerHeight();
    var top_of_screen = $(window).scrollTop();
    if ((bottom_of_screen > top_of_element) && (top_of_screen < bottom_of_element)){ 
    } else {
      $('#testimonial_video').trigger('pause');
      $(".play_icon").show();
    }
});

  $(".tab_head_num").click(function(){
$(this).siblings().removeClass("active");
$(this).addClass("active");
var index = $(this).attr("data-index");
$(".cstm_product_block .pro_num_"+ index).show();
$(".cstm_product_block .pro_num_"+ index).siblings().hide();
});


  


//faq section

$(".faq_Content .faq_qst").click(function(){
if($(this).hasClass("active"))
{
$(this).removeClass("active");
$(this).find("i").removeClass("fa-minus");
$(this).siblings(".faq_ans").hide()
$(this).find("i").addClass("fa-plus");
}
else
{
$(".faq_Content_wrapper").each(function(){
$(this).find(".faq_qst").removeClass("active");
$(this).find("i").removeClass("fa-minus");
$(this).find("i").addClass("fa-plus");
$(this).find(".faq_ans").hide()
});

$(this).addClass("active");
$(this).find("i").removeClass("fa-plus");
$(this).siblings(".faq_ans").show()
$(this).find("i").addClass("fa-minus");
}
}); 


 

  // change text of add to cart button at product page
  $(".add-to-cart").click(function(){
$(this).find("span").text("ADDED TO CART");
setTimeout(function () {
$(".add-to-cart").find("span").text("ADD TO CART");
}, 2000);
});

//scroll to contact form in coming soon page
  $(".cont_us").click(function(){
$('html, body').animate({
              scrollTop: $(".contact_sec").offset().top - 100
        }, 1000); 
});

  //add class on scroll in comingsoon header
  $(window).scroll(function() {    
    var scroll = $(window).scrollTop();
    if (scroll >= 100) {
        $("#shopify-section-main-password-header").addClass("darkHeader");
    } else {
        $("#shopify-section-main-password-header").removeClass("darkHeader");
    }
});

//coming soon toggle button on mobile
$(".toggle_icon").click(function(){
$(".mob_menu").show();
$(".mob_menu").addClass("mob_menu_open");
}); 
$(".cancel_div").click(function(){
$(".mob_menu").hide();
$(".mob_menu").removeClass("mob_menu_open");
});
  $(".mob_cont_us").click(function(){
$(".mob_menu").hide();
$(".mob_menu").removeClass("mob_menu_open");
});
  



   (function () {
        const second = 1000,
        minute = second * 60,
        hour = minute * 60,
        day = hour * 24;

  //I'm adding this section so I don't have to keep updating this pen every year :-)
  //remove this if you don't need it
      let today = new Date(),
      dd = String(today.getDate()).padStart(2, "0"),
      mm = String(today.getMonth() + 1).padStart(2, "0"),
      yyyy = today.getFullYear(),
      nextYear = yyyy + 1,
      dayMonth = document.getElementById('counter-date-time').value,
      birthday = dayMonth + yyyy;
      today = mm + "/" + dd + "/" + yyyy;
      if (today > birthday) {
        birthday = dayMonth + nextYear;
      }
  //end
  
  const countDown = new Date(birthday).getTime(),
      x = setInterval(function() {    
        const now = new Date().getTime(),
        distance = countDown - now;
          document.getElementById("days").innerText = Math.floor(distance / (day)),
          document.getElementById("hours").innerText = Math.floor((distance % (day)) / (hour)),
          document.getElementById("minutes").innerText = Math.floor((distance % (hour)) / (minute)),
          document.getElementById("seconds").innerText = Math.floor((distance % (minute)) / second);
        //do something later when date is reached
        if (distance < 0) {
          document.getElementById("headline").innerText = "It's my birthday!";
          document.getElementById("countdown").style.display = "none";
          document.getElementById("content").style.display = "block";
          clearInterval(x);
        }
        //seconds
      }, 0)
  }());

});

/*spicy web js*/  
  const swAccordion = document.getElementById("sw-accordion");
const swAccordionQuestions = document.querySelectorAll(".sw-accordion-question");
const swAccordionAnswers = document.querySelectorAll(".sw-accordion-answer");


if (swAccordion && swAccordionQuestions && swAccordionAnswers) {
swAccordion.classList.toggle("sw-display-none");
swAccordionQuestions.forEach((question, i) => {
question.addEventListener("click", function (e) {
question.classList.toggle("sw-accordion-active");
swAccordionAnswers[i].classList.toggle("sw-display-none");
});
});
}

// Elements
const parentElement = document.querySelector('#footer_menu_list-2');
const swFooterButton = document.getElementById('sw-footer-button');                 // Existing button
const productFooterButton = document.getElementById('sw-products-footer-button');    // Popular Products button

const swFooterContainer = document.getElementById('sw-footer-container');           // Existing list (brands/models)
const swPopularContainer = document.getElementById('sw-products-footer-container');         // New Popular Products list

// Move buttons into the parent, with Popular directly under the first
if (parentElement && swFooterButton) {
  parentElement.appendChild(swFooterButton);
  if (productFooterButton) swFooterButton.insertAdjacentElement('afterend', productFooterButton);
}

// Helper to hook a button to a container, and hide the other container when opened
function connect(button, container, otherContainer) {
  if (!button || !container) return;

  button.setAttribute('aria-controls', container.id);
  button.setAttribute('aria-expanded', 'false');

  button.addEventListener('click', () => {
    const isHidden = container.classList.contains('sw-display-none');

    // Toggle this one
    container.classList.toggle('sw-display-none');
    button.setAttribute('aria-expanded', String(isHidden));

    // Hide the other one (accordion behaviour)
    if (otherContainer && !otherContainer.classList.contains('sw-display-none')) {
      otherContainer.classList.add('sw-display-none');
      // (Optional) also collapse aria on the other button if you want to keep them in sync:
      // document.querySelector(`[aria-controls="${otherContainer.id}"]`)?.setAttribute('aria-expanded', 'false');
    }
  });
}

// Wire up: each button controls its own list
connect(swFooterButton, swFooterContainer, swPopularContainer);
connect(productFooterButton, swPopularContainer, swFooterContainer);

